module.exports = __webpack_public_path__ + "media/images/bg/footer-3b6d903d43e35a16545bb371c77174e8.svg";